import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Api {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  // auth section
  login(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}login`, data);
  }

  logout(): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}logout`, {});
  }

  getpermission(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}get_permissions`, data);
  }

  forgetPassword(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}forgot-password`, data);
  }

  verifyOtp(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}verify-otp`, data);
  }

  resendOtp(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}resend-otp`, data);
  }

  resetPassword(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}reset-password`, data);
  }

  // user section profile
  getUser(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}profile`);
  }

  updateUserprofile(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}profile/update`, data);
  }

  changePassword(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}profile/change-password`, data);
  }

  // designation

  getDesignations(params?: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}designations`, { params });
  }

  createDesignation(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}designations`, data);
  }

  editDesignation(data: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}designations/${data.id}`);
  }

  updateDesignation(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}designations/${data.id}`, data);
  }

  deleteDesignation(data: any): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}designations/${data.id}`);
  }

  // department

  getDepartments(params?: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}departments`, { params });
  }

  getAllDepartments(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}departments`);
  }

  createDepartment(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}departments`, data);
  }

  editDepartment(data: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}departments/${data.id}`);
  }

  updateDepartment(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}departments/${data.id}`, data);
  }

  deleteDepartment(data: any): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}departments/${data.id}`);
  }

  // roles
  getRoles(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}roles`);
  }

  getSingleRole(data: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}roles/${data.id}`);
  }

  createRole(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}roles`, data);
  }

  updateRole(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}roles/${data.id}`, data);
  }

  deleteRole(id: any): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}roles/${id}`);
  }

  bulkAssignPermissions(data: { role_id: any, permissions: string[] }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}roles/bulk-assign-permissions`, data);
  }

  // users
  getUsers(params?: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}users`, { params });
  }

  getAllUsers(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}all_users`);
  }

  createUser(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}users`, data);
  }

  editUser(data: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}users/${data.id}`);
  }

  updateUser(id: any, data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}users/${id}`, data);
  }

  activeOrInactiveUser(id: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}users/${id}/toggle-status`, {});
  }

  // accounts heads
  getAccountsHeads(params?: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}account_heads`, { params });
  }

  getAccountsAllHeads(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}account_heads`);
  }

  createAccountsHead(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}account_heads`, data);
  }

  updateAccountsHead(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}account_heads/${data.id}`, data);
  }

  deleteAccountsHead(data: any): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}account_heads/${data.id}`);
  }

  // budget info
  createBudgetInfo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}account_heads/budgets`, data);
  }

  getYearlyBudgetInfo(params: any = {}): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}account_heads/budgets/yearly`, { params });
  }

  deleteBudgetInfo(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}account_heads/budgets/${id}`);
  }

  updateBudgetInfo(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}account_heads/budgets/${id}`, data);
  }

  getBudgetDetails(params: { head_id: number, memo_id: number }): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}account_heads/budgets/details`, { params });
  }

  // general approval memo
  getMemoRefNo(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}memo_sheet/generate_approval_ref`);
  }

  getMemoData(params: any = {}): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}memo_sheet/requisition_list`, { params });
  }

  getRequisitionDetailsById(id: string | number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}memo_sheet/requisition_details/${id}`);
  }

  createMemo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}memo_sheet/requisition_create`, data);
  }

  editMemo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}memo_sheet/requisition_edit`, data);
  }

  approveMemo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}memo_sheet/requisition_approve`, data);
  }

  rejectAndChangeMemo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}memo_sheet/return_for_resubmit`, data);
  }

  delegateRequisition(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}requisition/delegate`, data);
  }

  // activity logs
  getActivityLogs(params?: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}profile/activity-logs`, { params });
  }

  // registration
  getRegistrationData(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}registration-form-data`);
  }

  registerGuest(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}guest-register`, data);
  }

  // approval payment memo
  getPaymentMemoRefNo(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}payment_memo/generate_approval_ref`);
  }

  createPaymentMemo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}payment_memo/requisition_create`, data);
  }

  getPaymentMemoData(params: any = {}): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}payment_memo/requisition_list`, { params });
  }

  getPaymentMemoDetailsById(id: string | number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}payment_memo/requisition_details/${id}`);
  }

  editPaymentMemo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}payment_memo/requisition_edit`, data);
  }

  approvePaymentMemo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}payment_memo/requisition_approve`, data);
  }

  rejectAndChangePaymentMemo(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}payment_memo/return_for_resubmit`, data);
  }

  delegatePaymentRequisition(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}payment_memo/delegate`, data);
  }

  // dashboard section
  getDashboardStats(params?: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}dashboard/stats`, { params });
  }

  getApprovalBarChart(params?: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}dashboard/approval-bar-chart`, { params });
  }

}
